import { getAppStore } from '@src/utils/store-reference';
import { useMutation } from '@tanstack/react-query';
import { FileStorageMutations } from '../mutation';
import { LoadingMessages, ResponseStatuses, StorageScopes } from '@src/utils/enums';
import { toast } from 'react-toastify';
import { useApp, useRequest } from '@src/stores';

type FileStorageUploadMutationParams = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateFn: (data: any) => void;
};

export const useFileStorageUploadMutation = () => {
  const store = getAppStore();
  const { selectedRequestId } = useRequest.getState();
  const { setIsLoading, setIsSavingProgress } = useApp.getState();
  const reqTypeId = Number(selectedRequestId);

  return useMutation({
    mutationFn: async ({ data }: FileStorageUploadMutationParams) => {
      const payload = {
        projectId: data?.projectID,
        requestId: data?.request?.requestID,
        version: data?.request?.version,
        fileData: store.selectValidFiles(),
      };

      setIsLoading(true, LoadingMessages.UploadFile);
      setIsSavingProgress(true);

      const results = await FileStorageMutations.uploadRequestFiles(payload);
      setIsLoading(false);
      setIsSavingProgress(false);
      return results;
    },
    onSuccess: async (data, variables) => {
      // @TODO: Add the rest of the request types as update logic gets migrated to React-Query/Zustand
      const componentIdMapping: { [key: number]: number } = {
        11: variables?.data?.request?.nonPCNRequests?.[0]?.nonPcnRequestID,
      };

      if (data?.status === ResponseStatuses.Success) {
        variables.updateFn(variables.data);
        store.doResetUsersFileData();
        store.doFetchUserFilesDetails({
          componentID: componentIdMapping[reqTypeId],
          scope: StorageScopes.ProjectFolder,
        });
      }
    },
    onError: (error) => {
      toast.error('Failed to save attachments.');
      console.error('Failed to save attachments: ', error);
      setIsSavingProgress(false);
      store.doResetUsersFileData();
    },
  });
};
